import { render, staticRenderFns } from "./terra.vue?vue&type=template&id=3acfda34&scoped=true"
import script from "./terra.vue?vue&type=script&lang=js"
export * from "./terra.vue?vue&type=script&lang=js"
import style0 from "./terra.vue?vue&type=style&index=0&id=3acfda34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acfda34",
  null
  
)

export default component.exports